import { hasCapability, type User } from "../base";

export const salesDetails = {
  read: (user: User) => hasCapability(user, "salesDetails.read"),
};
